import { Box } from '@mui/material';
import { Checkbox, useFormContext } from 'framework/form';
import { Button } from 'framework/ui/mui-builder';

const SignComplianceDocument = () => {
  const { isSubmitEnabled, data: formData, submitForm } = useFormContext();
  const { isComplianceAccepted: isChecked } = formData || {};

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        '.MuiFormControl-root': { mb: 0, '> label': { mr: 0 } },
      }}
    >
      <Checkbox label="I agree to sign and follow the compliance" source="isComplianceAccepted" />

      <Button disabled={!isChecked || !isSubmitEnabled} onClick={submitForm} color="primary">
        Sign
      </Button>
    </Box>
  );
};

export default SignComplianceDocument;
